import { useLocale } from "@/i18n/LocaleProvider";
import { LocalizedText } from "@/i18n/LocalizedText";
import { Button } from "@/components/ui/button";
import { authAPI } from "@/services/api";
import { auth } from "@/firebase";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/components/AuthContext";
import { toast } from "sonner";
import { TriangleAlert } from "lucide-react";

const ComingSoonPage = () => {
  const { t } = useLocale();
  const navigate = useNavigate();
  const { setLoading } = useAuth();

  const handleSignOut = async () => {
    setLoading(true);
    try {
      const [apiLogoutResult, firebaseSignOutResult] = await Promise.allSettled(
        [authAPI.logout(), signOut(auth)],
      );

      if (
        apiLogoutResult.status === "rejected" &&
        firebaseSignOutResult.status === "rejected"
      ) {
        toast.error(t("legacy.couldnt.log.out.1diajr7"), {
          icon: (
            <div className="w-6 h-6 bg-muted rounded-lg flex items-center justify-center">
              <TriangleAlert className="w-4 h-4 text-black" />
            </div>
          ),
          position: "bottom-right",
        });
      }

      navigate("/login", { replace: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted px-4">
      <div className="w-full max-w-lg rounded-2xl border bg-white p-8 shadow-sm text-center">
        <h1 className="text-2xl font-semibold mb-3">
          <LocalizedText id="legacy.coming.soon.1o7x1i1" />
        </h1>
        <p className="text-muted-foreground mb-6">
          <LocalizedText id="legacy.thanks.for.your.interest.in.nobori.1lcfb0y" />
        </p>
        <div className="flex flex-col gap-3">
          <Button
            onClick={handleSignOut}
            className="bg-[#FF5E00] hover:bg-[#ff8138] text-white cursor-pointer"
          >
            <LocalizedText id="legacy.back.to.sign.in.16hh1k1" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
